'use strict';

var RouteIds = require('@workforcesoftware/lighthouse-framework');
var React = require('react');
var lighthouseComponentLibrary = require('@workforcesoftware/lighthouse-component-library');
var experience = require('@foko/experience');
var Skeleton = require('@material-ui/lab/Skeleton');
var polished = require('polished');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var Box = require('@material-ui/core/Box');
var dompurify = require('dompurify');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var RouteIds__default = /*#__PURE__*/_interopDefault(RouteIds);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Skeleton__default = /*#__PURE__*/_interopDefault(Skeleton);
var Box__default = /*#__PURE__*/_interopDefault(Box);
var dompurify__default = /*#__PURE__*/_interopDefault(dompurify);

var BROADCASTS = {
	CARD_TITLE: {
		TARGET: "Broadcasts",
		NOTE: "Text header displayed in the Broadcast hub card."
	},
	EMPTY_CARD: {
		TARGET: "There are currently no broadcasts",
		NOTE: "Text presented in the Broadcast hub card when there are no items to show."
	},
	ERROR_MSG: {
		TARGET: "Sorry, looks like there was a problem getting this information.",
		NOTE: "Text displayed in the Broadcast hub card in case of error. i.e. API error."
	},
	EXPIRES: {
		TARGET: "Expires {{expDate}}",
		NOTE: "Text to inform the expiration date of the broadcast."
	},
	NEW_INDICATOR: {
		TARGET: "New",
		NOTE: "Information overlay on hubcard to indicate that there is a new unread broadcast"
	},
	VIEW_MORE: {
		TARGET: "View more",
		NOTE: "Text of the link to see more details of the in context broadcast."
	},
	VIEW_MORE_ADVISORY: {
		TARGET: "View more details",
		NOTE: "Advisory text of the link to see more details of the in context broadcast."
	},
	VIEW_ALL: {
		TARGET: "All broadcasts",
		NOTE: "Text of the link to see all broadcasts."
	},
	VIEW_ALL_ADVISORY: {
		TARGET: "View all broadcasts",
		NOTE: "Avisory text of the link to see all broadcasts."
	},
	ATTACHMENTS: {
		TARGET: "Attachments",
		NOTE: "Text to inform the broadcast contains attachments"
	},
	FROM: {
		TARGET: "From: {{department}}",
		NOTE: "Text to specify the originating deparment for the broadcast"
	}
};
var EnglishUS$1 = {
	BROADCASTS: BROADCASTS
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var Container$3 = lighthouseComponentLibrary.styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"])));
var Content$1 = lighthouseComponentLibrary.styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  border-radius: ", ";\n  border: 1px solid;\n  padding: ", ";\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid\n    ", ";\n  &.unread {\n    border-color: ", ";\n  }\n  &.urgent {\n    border-color: ", ";\n  }\n"], ["\n  border-radius: ", ";\n  border: 1px solid;\n  padding: ", ";\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid\n    ", ";\n  &.unread {\n    border-color: ",
    ";\n  }\n  &.urgent {\n    border-color: ", ";\n  }\n"])), polished.rem("4px"), polished.rem("16px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[400]; }, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.information.main;
}, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.warning.main; });
var PillOverlay = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  position: relative;\n  top: ", ";\n  right: ", ";\n  margin-top: -", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", " ", "\n  color: ", ";\n"], ["\n  position: relative;\n  top: ", ";\n  right: ", ";\n  margin-top: -", ";\n  background-color: ",
    ";\n  border-radius: ", ";\n  padding: ", " ", "\n  color: ", ";\n"])), polished.rem("13px"), polished.rem("16px"), polished.rem("26px"), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.information.main;
}, polished.rem("8px"), polished.rem("4px"), polished.rem("16px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.white; });
var BroadcastContent = function (props) {
    var children = props.children, _a = props.isUrgent, isUrgent = _a === void 0 ? false : _a, _b = props.isUnread, isUnread = _b === void 0 ? false : _b;
    return (React__namespace.default.createElement(lighthouseComponentLibrary.CardContent, null,
        React__namespace.default.createElement(Container$3, null,
            isUnread ? (React__namespace.default.createElement(PillOverlay, { use: "caption" }, i18nHelper$1.translate("BROADCASTS.NEW_INDICATOR"))) : null,
            React__namespace.default.createElement(Content$1, { className: (isUnread ? "unread" : "") + " " + (isUrgent ? "urgent" : "") }, children))));
};
var templateObject_1$7, templateObject_2$6, templateObject_3$2;

var Container$2 = lighthouseComponentLibrary.styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 250px;\n  text-align: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 250px;\n  text-align: center;\n"])));
var Text = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 1rem;\n  display: block;\n"], ["\n  font-weight: 400;\n  font-size: 1rem;\n  display: block;\n"])));
var EmptyCard = function (props) {
    var theme = RouteIds.useTheme();
    var message = props.message;
    return (React__namespace.default.createElement(Container$2, null,
        React__namespace.default.createElement("div", null,
            React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faSun, color: theme.colours.grey.tone["600"], size: "2x" }),
            React__namespace.default.createElement(Text, { use: "captionMedium" }, message))));
};
var templateObject_1$6, templateObject_2$5;

var Container$1 = lighthouseComponentLibrary.styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  & :first-child {\n    margin-right: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  & :first-child {\n    margin-right: ", ";\n  }\n"])), polished.rem("15px"));
var ErrorCard = function (props) {
    var message = props.message;
    var theme = RouteIds.useTheme();
    return (React__namespace.default.createElement(lighthouseComponentLibrary.CardContent, null,
        React__namespace.default.createElement(Container$1, null,
            React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faExclamationTriangle, color: theme.colours.error.main }),
            message)));
};
var templateObject_1$5;

/**
 * @todo: possibly centralize in future
 */
var BroadcastCardActionBar = function (props) {
    var _a = props.display, display = _a === void 0 ? "flex" : _a, _b = props.flexDirection, flexDirection = _b === void 0 ? "row" : _b, _c = props.flexWrap, flexWrap = _c === void 0 ? "wrap" : _c, _d = props.justifyContent, justifyContent = _d === void 0 ? "space-between" : _d, _e = props.width, width = _e === void 0 ? "100%" : _e, rest = __rest(props, ["display", "flexDirection", "flexWrap", "justifyContent", "width"]);
    return (React__namespace.default.createElement(Box__default.default, __assign({ display: display, flexDirection: flexDirection, flexWrap: flexWrap, justifyContent: justifyContent, width: width }, rest)));
};

var Actions$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.CardActions)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  padding: ", " !important;\n"], ["\n  padding: ", " !important;\n"])), polished.rem("16px"));
var Pager = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Pagination)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  & .MuiTablePagination-toolbar {\n    padding: 0;\n  }\n  & button {\n    padding: ", ";\n    margin 0 !important;\n  }\n"], ["\n  & .MuiTablePagination-toolbar {\n    padding: 0;\n  }\n  & button {\n    padding: ", ";\n    margin 0 !important;\n  }\n"])), polished.rem("8px"));
var Pages = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  padding: 0 ", ";\n"], ["\n  padding: 0 ", ";\n"])), polished.rem("8px"));
var BroadcastCardActions = function (props) {
    var broadcasts = props.broadcasts, onChange = props.onChange;
    var _a = React.useState(0), page = _a[0], setPage = _a[1];
    var wfxUrl = RouteIds.useWfxAppUrl();
    var wfxBroadcastsRoute = "" + wfxUrl + RouteIds__default.default.FrameworkRouteIds.wfxBroadcastsRoute;
    return (React__namespace.default.createElement(Actions$1, null,
        React__namespace.default.createElement(BroadcastCardActionBar, null,
            React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(Pager, { rowsPerPageOptions: [], count: broadcasts.length, rowsPerPage: 1, page: page, onChangePage: function (e, index) {
                        onChange(broadcasts[index]);
                        setPage(index);
                    }, onChangeRowsPerPage: function () { return undefined; }, component: "div", labelDisplayedRows: function (_a) {
                        var from = _a.from; _a.to; var count = _a.count;
                        return (React__namespace.default.createElement(Pages, { use: "caption" },
                            from,
                            "-",
                            count));
                    } }),
                React__namespace.default.createElement(lighthouseComponentLibrary.Link, { title: i18nHelper$1.translate("BROADCASTS.VIEW_ALL_ADVISORY"), "data-qa": "allBroadcastsLink", onClick: function () {
                        RouteIds.embedExternalPage(encodeURI(wfxBroadcastsRoute));
                    } }, i18nHelper$1.translate("BROADCASTS.VIEW_ALL"))))));
};
var templateObject_1$4, templateObject_2$4, templateObject_3$1;

// Set time format to short month, short weekday and numeric day e.g. Tue, Sep 26
var shortDateFormatOption = {
    weekday: "short",
    month: "short",
    day: "numeric",
};

var BroadcastPriority;
(function (BroadcastPriority) {
    BroadcastPriority["URGENT"] = "URGENT";
    BroadcastPriority["NORMAL"] = "NORMAL";
})(BroadcastPriority || (BroadcastPriority = {}));

var HeadContent = lighthouseComponentLibrary.styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: ", ";\n"])), polished.rem("10px"));
var Department = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  margin: 0;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-wrap: break-word;\n  margin-right: ", ";\n"], ["\n  margin: 0;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-wrap: break-word;\n  margin-right: ", ";\n"])), polished.rem("10px"));
var Title = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 400;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.5;\n  word-wrap: break-word;\n"], ["\n  font-weight: 400;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.5;\n  word-wrap: break-word;\n"])));
var Description = lighthouseComponentLibrary.styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 7;\n  -webkit-box-orient: vertical;\n"], ["\n  font-size: ", ";\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 7;\n  -webkit-box-orient: vertical;\n"])), polished.rem("14px"));
var Dates = lighthouseComponentLibrary.styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"])));
var TitleHeader = lighthouseComponentLibrary.styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  & :first-child {\n    margin-right: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  & :first-child {\n    margin-right: ", ";\n  }\n"])), polished.rem("16px"));
var AttachmentIndicator = lighthouseComponentLibrary.styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  div {\n    margin-left: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  div {\n    margin-left: ", ";\n  }\n"])), polished.rem("5px"));
var convertImages = function (images) {
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return [];
    }
    return images.map(function (image) {
        return ({
            key: image.id,
            height: image.small.height,
            width: image.small.width,
            src: image.small.url,
        });
    });
};
var BroadcastCardContent = function (props) {
    var _a, _b;
    var currentBroadcast = props.currentBroadcast;
    var theme = RouteIds.useTheme();
    var wfxUrl = RouteIds.useWfxAppUrl();
    var wfxBroadcastsRoute = "" + wfxUrl + RouteIds__default.default.FrameworkRouteIds.wfxBroadcastsRoute;
    return (React__namespace.default.createElement(BroadcastContent, { isUrgent: (currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.priority) === BroadcastPriority.URGENT, isUnread: !(currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.isRead) },
        React__namespace.default.createElement(HeadContent, null,
            React__namespace.default.createElement(Department, { use: "caption" }, i18nHelper$1.translate("BROADCASTS.FROM", {
                department: (_a = currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.department) === null || _a === void 0 ? void 0 : _a.name,
            })),
            React__namespace.default.createElement(Dates, null,
                React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "caption" },
                    React__namespace.default.createElement(RouteIds.DateTime, { date: new Date(currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.visibleDate), options: shortDateFormatOption })),
                (currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.archiveDate) ? (React__namespace.default.createElement(lighthouseComponentLibrary.Typography, { use: "caption" }, i18nHelper$1.translate("BROADCASTS.EXPIRES", {
                    expDate: RouteIds.formatDateTime(new Date(currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.archiveDate), shortDateFormatOption),
                }))) : null)),
        React__namespace.default.createElement(TitleHeader, null,
            (currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.priority) === BroadcastPriority.URGENT ? (React__namespace.default.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faFire, color: theme.colours.warning.main, size: "lg" })) : null,
            React__namespace.default.createElement(Title, { use: "h3" }, currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.title)),
        ((_b = currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.loadedImages) === null || _b === void 0 ? void 0 : _b.length) ? (React__namespace.default.createElement(lighthouseComponentLibrary.ImageGallery, { images: convertImages(currentBroadcast.loadedImages) })) : (React__namespace.default.createElement(Description, { dangerouslySetInnerHTML: {
                __html: dompurify__default.default.sanitize(currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.description),
            } })),
        React__namespace.default.createElement(BroadcastCardActionBar, { marginTop: polished.rem("16px") },
            React__namespace.default.createElement(React__namespace.default.Fragment, null,
                (currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.attachmentIds.length) > 0 ? (React__namespace.default.createElement(AttachmentIndicator, null,
                    React__namespace.default.createElement(lighthouseComponentLibrary.IconV2, { icon: "paperclip", fontSize: "small" }),
                    React__namespace.default.createElement("div", null, i18nHelper$1.translate("BROADCASTS.ATTACHMENTS")))) : null,
                React__namespace.default.createElement("div", { style: { flex: 1 } }),
                React__namespace.default.createElement(lighthouseComponentLibrary.Link, { title: i18nHelper$1.translate("BROADCASTS.VIEW_MORE_ADVISORY"), "data-qa": "broadcastLink", onClick: function () {
                        var broadcastId = currentBroadcast === null || currentBroadcast === void 0 ? void 0 : currentBroadcast.broadcastId;
                        if (broadcastId) {
                            var wfxBroadcastLink = wfxBroadcastsRoute + "#broadcastId_" + broadcastId;
                            RouteIds.embedExternalPage(encodeURI(wfxBroadcastLink));
                        }
                    } }, i18nHelper$1.translate("BROADCASTS.VIEW_MORE"))))));
};
var templateObject_1$3, templateObject_2$3, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var ImagesService = {
    getImages: function (imageIds) { return __awaiter(void 0, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, experience.FileService.getFiles(imageIds)];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (image) {
                            image.createdAt = new Date(image.createdAt);
                            image.updatedAt = new Date(image.updatedAt);
                            return image;
                        })];
            }
        });
    }); },
};

var BroadcastCardService = {
    loadImages: function (broadcastData) { return __awaiter(void 0, void 0, void 0, function () {
        var imageIds, _i, broadcastData_1, broadcast, images, imageMap, _a, broadcastData_2, broadcast, _b, _c, imageId;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    imageIds = new Set();
                    for (_i = 0, broadcastData_1 = broadcastData; _i < broadcastData_1.length; _i++) {
                        broadcast = broadcastData_1[_i];
                        if ((_d = broadcast.imageIds) === null || _d === void 0 ? void 0 : _d.length) {
                            // only retrieve first 3 images of each broadcast
                            broadcast.imageIds
                                .slice(0, 3)
                                .forEach(function (imageId) { return imageIds.add(imageId); });
                        }
                    }
                    if (!imageIds.size) {
                        return [2 /*return*/, broadcastData];
                    }
                    return [4 /*yield*/, ImagesService.getImages(Array.from(imageIds))];
                case 1:
                    images = _f.sent();
                    imageMap = new Map(images.map(function (image) { return [image.id, image]; }));
                    for (_a = 0, broadcastData_2 = broadcastData; _a < broadcastData_2.length; _a++) {
                        broadcast = broadcastData_2[_a];
                        if ((_e = broadcast.imageIds) === null || _e === void 0 ? void 0 : _e.length) {
                            for (_b = 0, _c = broadcast.imageIds; _b < _c.length; _b++) {
                                imageId = _c[_b];
                                if (imageMap.has(imageId)) {
                                    if (!broadcast.loadedImages) {
                                        broadcast.loadedImages = [];
                                    }
                                    broadcast.loadedImages.push(imageMap.get(imageId));
                                }
                            }
                        }
                    }
                    return [2 /*return*/, broadcastData];
            }
        });
    }); },
};

var BroadcastCard = function () {
    var _a = React.useState([]), broadcasts = _a[0], setBroadcasts = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(false), error = _c[0], setError = _c[1];
    var _d = React.useState(broadcasts[0]), currentBroadcast = _d[0], setCurrentBroadcast = _d[1];
    var wfsWfxSession = RouteIds.useLocaleStorageEventListener(experience.LOCAL_STORAGE_KEYS.WFS_WFX_SESSION).currentValue;
    React.useEffect(function () {
        if (RouteIds.hasValidWfxSession()) {
            // get hub cards
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, 4, 5]);
                            return [4 /*yield*/, experience.BroadcastsService.getBroadcastHubCards()];
                        case 1:
                            res = _a.sent();
                            return [4 /*yield*/, BroadcastCardService.loadImages(res)];
                        case 2:
                            res = _a.sent();
                            setBroadcasts(res);
                            setCurrentBroadcast(res[0]);
                            return [3 /*break*/, 5];
                        case 3:
                            _a.sent();
                            setError(true);
                            return [3 /*break*/, 5];
                        case 4:
                            setIsLoading(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [wfsWfxSession]);
    var loader = (React__namespace.default.createElement(lighthouseComponentLibrary.CardContent, null,
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text", width: "80%" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text", width: "80%" })));
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Card, { "data-qa": "broadcastCard" },
        React__namespace.default.createElement(lighthouseComponentLibrary.CardHeader, { title: i18nHelper$1.translate("BROADCASTS.CARD_TITLE"), headerIcon: "megaphone" }),
        (function () {
            if (isLoading) {
                return loader;
            }
            if (error) {
                return (React__namespace.default.createElement(ErrorCard, { message: i18nHelper$1.translate("BROADCASTS.ERROR_MSG") }));
            }
            if ((broadcasts === null || broadcasts === void 0 ? void 0 : broadcasts.length) === 0) {
                return (React__namespace.default.createElement(BroadcastContent, null,
                    React__namespace.default.createElement(EmptyCard, { message: i18nHelper$1.translate("BROADCASTS.EMPTY_CARD") })));
            }
            return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(BroadcastCardContent, { currentBroadcast: currentBroadcast }),
                React__namespace.default.createElement(BroadcastCardActions, { broadcasts: broadcasts, onChange: function (current) { return setCurrentBroadcast(current); } })));
        })()));
};

var routes = [
    {
        id: "broadcasts",
        route: "/broadcastsCard",
        component: BroadcastCard,
        restricted: true,
    },
];

var I18nHelper = /** @class */ (function () {
    function I18nHelper() {
        var _this = this;
        this.setFrameworkI18n = function (i18n) {
            _this.frameworkI18n = i18n;
        };
        this.translate = function (key, substitutions) {
            return _this.frameworkI18n.translate(key, substitutions);
        };
        this.getTextDirection = function () {
            return _this.frameworkI18n.getTextDirection();
        };
    }
    return I18nHelper;
}());

var BroadcastHubCardIds;
(function (BroadcastHubCardIds) {
    BroadcastHubCardIds["BroadcastsCard"] = "broadcasts/broadcastsCard";
})(BroadcastHubCardIds || (BroadcastHubCardIds = {}));
var BroadcastHubCardSpecification = {
    getId: function () { return BroadcastHubCardIds.BroadcastsCard; },
    getName: function () { return i18nHelper$1.translate("BROADCASTS.CARD_TITLE"); },
    getConfig: function () { return ({}); },
};
/**
 * Get the hub card specifications.
 * @return HubCardSpecifications Broadcast object { getId: () => 'broadcasts/broadcastsCard',
 *                                                  getName: () => 'Broadcasts',
 *                                                  getConfig: () => ({}) }
 */
var getHubCardSpecs$1 = function (hubCardId) {
    var _a;
    var hubCardSpecs = (_a = {},
        _a[BroadcastHubCardIds.BroadcastsCard] = BroadcastHubCardSpecification,
        _a);
    return hubCardSpecs[hubCardId];
};

/**
 * Creates and returns the hub card component for the given specification.
 * Edit mode awareness and a function to change the hub card's configuration
 * should be injected here.
 */
var create$1 = function (cardSpecification, editMode, changeHubCardConfig) {
    if (cardSpecification.getId() === BroadcastHubCardIds.BroadcastsCard) {
        return (React__namespace.createElement(BroadcastCard, __assign({}, cardSpecification, { editMode: editMode, changeHubCardConfig: changeHubCardConfig })));
    }
    throw new Error("Unknown card id: " + cardSpecification.getId());
};
/**
 * Get the broadcast hub card if the current user is allowed to access.
 * @return Promise<HubCardSpecifications[]> Broadcast hub card if the user is allowed to access it.
 */
var getBroadcastHubCard = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hubCardSpecifications;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    shouldBroadcastHubCardAppear().then(function (result) {
                        if (result) {
                            return getHubCardSpecs$1(BroadcastHubCardIds.BroadcastsCard);
                        }
                        return undefined;
                    }),
                ])];
            case 1:
                hubCardSpecifications = (_a.sent()).filter(Boolean);
                return [2 /*return*/, hubCardSpecifications];
        }
    });
}); };
/**
 * Check if the Broadcast hub card should appear.
 */
var shouldBroadcastHubCardAppear = function () {
    var isBroadcastsEnabled = RouteIds.getFrameworkInstance().getNamedFeatureFlags(RouteIds.WfxFeatureFlagKey.BROADCASTS)
        .wfx_broadcasts && RouteIds.hasValidWfxSession();
    return Promise.resolve(isBroadcastsEnabled);
};

var i18nHelper$1 = new I18nHelper();
var hubCardFactory = {
    create: create$1,
    getCardSpecifications: getBroadcastHubCard,
};
var BroadcastsModule = {
    getId: function () { return "broadcasts-ui"; },
    getName: function () { return "Broadcasts"; },
    setFrameworkInstance: RouteIds.setFrameworkInstance,
    setI18nInstance: function (instance) {
        i18nHelper$1.setFrameworkI18n(instance);
    },
    getRouteSpecifications: function () { return routes; },
    getI18nResources: function () {
        return {
            "en-US": EnglishUS$1,
        };
    },
    getReducers: function () { return ({}); },
    getHubCardFactory: function () { return hubCardFactory; },
};

var TASKS_ASSIGNEE = {
	CARD_TITLE: {
		TARGET: "Tasks",
		NOTE: "Text header displayed in the Tasks Assignee hub card."
	},
	EMPTY_CARD: {
		TARGET: "There are currently no assigned tasks",
		NOTE: "Text presented in the Tasks Assignee hub card when there are no items to show."
	},
	ERROR_MSG: {
		TARGET: "Sorry, looks like there was a problem getting this information.",
		NOTE: "Text displayed in the Tasks Assignee hub card in case of error. i.e. API error."
	},
	OVERDUE: {
		TARGET: "Overdue",
		NOTE: "Text displayed on the button indicating any currently overdue assigned tasks."
	},
	DUE_TODAY: {
		TARGET: "Due today",
		NOTE: "Text displayed on the button indicating any currently assigned tasks due today."
	},
	ONGOING: {
		TARGET: "Ongoing",
		NOTE: "Text displayed on the button indicating any currently ongoing tasks."
	},
	VIEW_ALL: {
		TARGET: "Tasks",
		NOTE: "Text of the link to see all assigned tasks."
	},
	VIEW_ALL_ADVISORY: {
		TARGET: "View all assigned tasks",
		NOTE: "Avisory text of the link to see all assigned tasks."
	}
};
var EnglishUS = {
	TASKS_ASSIGNEE: TASKS_ASSIGNEE
};

var TasksAssigneeActionBar = function (props) {
    var _a = props.display, display = _a === void 0 ? "flex" : _a, _b = props.flexDirection, flexDirection = _b === void 0 ? "row" : _b, _c = props.flexWrap, flexWrap = _c === void 0 ? "wrap" : _c, _d = props.justifyContent, justifyContent = _d === void 0 ? "space-between" : _d, _e = props.width, width = _e === void 0 ? "100%" : _e, rest = __rest(props, ["display", "flexDirection", "flexWrap", "justifyContent", "width"]);
    return (React__namespace.default.createElement(Box__default.default, __assign({ display: display, flexDirection: flexDirection, flexWrap: flexWrap, justifyContent: justifyContent, width: width }, rest)));
};

var Actions = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.CardActions)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n  }\n"], ["\n  && {\n    padding: ", ";\n  }\n"])), polished.rem("16px"));
var StyledLink$1 = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Link)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  && {\n    font-size: ", ";\n    font-weight: ", ";\n    padding: 0 ", ";\n  }\n"], ["\n  && {\n    font-size: ", ";\n    font-weight: ",
    ";\n    padding: 0 ", ";\n  }\n"])), polished.rem("14px"), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).type.fontWeights.semiBold;
}, polished.rem("8px"));
var TasksAssigneeCardActions = function () {
    var wfxUrl = RouteIds.useWfxAppUrl();
    var wfxTasksAssignedRoute = "" + wfxUrl + RouteIds__default.default.FrameworkRouteIds.wfxTasksAssignedRoute;
    return (React__namespace.default.createElement(Actions, null,
        React__namespace.default.createElement(TasksAssigneeActionBar, null,
            React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement("div", null),
                React__namespace.default.createElement(StyledLink$1, { title: i18nHelper.translate("TASKS_ASSIGNEE.VIEW_ALL_ADVISORY"), "data-qa": "allAssignedTasksLink", onClick: function () {
                        RouteIds.embedExternalPage(encodeURI(wfxTasksAssignedRoute));
                    } }, i18nHelper.translate("TASKS_ASSIGNEE.VIEW_ALL"))))));
};
var templateObject_1$2, templateObject_2$2;

var Container = lighthouseComponentLibrary.styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n"])));
var Content = lighthouseComponentLibrary.styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  padding: 0 0 ", ";\n  width: 100%;\n  ", ";\n"], ["\n  padding: 0 0 ", ";\n  width: 100%;\n  ", ";\n"])), polished.rem("16px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[400]; });
var TasksAssigneeContent = function (props) {
    var children = props.children;
    return (React__namespace.default.createElement(lighthouseComponentLibrary.CardContent, null,
        React__namespace.default.createElement(Container, null,
            React__namespace.default.createElement(Content, null, children))));
};
var templateObject_1$1, templateObject_2$1;

var StyledLink = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    border: 1px solid transparent;\n    border-radius: ", ";\n    color: inherit;\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    text-align: left;\n    width: 100%;\n  }\n\n  &&:hover {\n    text-decoration: none;\n  }\n\n  &&.overdue {\n    background-color: ", ";\n  }\n\n  &&.overdue:hover {\n    background-color: ", ";\n  }\n\n  &&.due-today {\n    background-color: ", ";\n  }\n\n  &&.due-today:hover {\n    background-color: ", ";\n  }\n\n  &&.ongoing {\n    background-color: ", ";\n  }\n\n  &&.ongoing:hover {\n    background-color: ", ";\n  }\n"], ["\n  && {\n    border: 1px solid transparent;\n    border-radius: ", ";\n    color: inherit;\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    text-align: left;\n    width: 100%;\n  }\n\n  &&:hover {\n    text-decoration: none;\n  }\n\n  &&.overdue {\n    background-color: ",
    ";\n  }\n\n  &&.overdue:hover {\n    background-color: ",
    ";\n  }\n\n  &&.due-today {\n    background-color: ",
    ";\n  }\n\n  &&.due-today:hover {\n    background-color: ",
    ";\n  }\n\n  &&.ongoing {\n    background-color: ",
    ";\n  }\n\n  &&.ongoing:hover {\n    background-color: ",
    ";\n  }\n"])), polished.rem("8px"), polished.rem("16px"), function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).type.fontWeights.bold; }, polished.rem("24px"), polished.rem("16px"), function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.tone[50];
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.tone[100];
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[50];
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.tone[100];
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[50];
}, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.tone[100];
});
var StyledBadge = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Badge)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    display: flex;\n  }\n\n  & .MuiBadge-anchorOriginTopRightRectangle {\n    border-color: transparent;\n    margin-right: 0.6rem;\n    top: 0.1rem;\n  }\n\n  ", ".overdue & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ", ";\n  }\n\n  ", ".due-today & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ", ";\n  }\n\n  ", ".ongoing & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ", ";\n  }\n"], ["\n  && {\n    display: flex;\n  }\n\n  & .MuiBadge-anchorOriginTopRightRectangle {\n    border-color: transparent;\n    margin-right: 0.6rem;\n    top: 0.1rem;\n  }\n\n  ", ".overdue & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ", ";\n  }\n\n  ", ".due-today & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ",
    ";\n  }\n\n  ", ".ongoing & .MuiBadge-anchorOriginTopRightRectangle {\n    background-color: ", ";\n  }\n"])), StyledLink, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.error.main; }, StyledLink, function (props) {
    return lighthouseComponentLibrary.getThemeFromProps(props).colours.primary.main;
}, StyledLink, function (props) { return lighthouseComponentLibrary.getThemeFromProps(props).colours.grey.main; });
var TasksAssigneeCardContent = function (props) {
    var tasksAssignee = props.tasksAssignee;
    var wfxUrl = RouteIds.useWfxAppUrl();
    var wfxTasksAssignedRoute = "" + wfxUrl + RouteIds__default.default.FrameworkRouteIds.wfxTasksAssignedRoute;
    return (React__namespace.default.createElement(TasksAssigneeContent, null,
        React__namespace.default.createElement(Box__default.default, { display: "flex", gridRowGap: polished.rem("16px"), flexDirection: "column", flexWrap: "wrap", alignContent: "start" },
            React__namespace.default.createElement(StyledLink, { "data-qa": "overdueTasksLink", className: "overdue", onClick: function () {
                    var wfxTasksOverdueLink = wfxTasksAssignedRoute + "#overDueTasks";
                    RouteIds.embedExternalPage(encodeURI(wfxTasksOverdueLink));
                } },
                React__namespace.default.createElement(StyledBadge, { badgeContent: tasksAssignee.overDue, max: 1000, variant: "standard" }, i18nHelper.translate("TASKS_ASSIGNEE.OVERDUE"))),
            React__namespace.default.createElement(StyledLink, { "data-qa": "dueTodayTasksLink", className: "due-today", onClick: function () {
                    var wfxTasksDueTodayLink = wfxTasksAssignedRoute + "#dueTodayTasks";
                    RouteIds.embedExternalPage(encodeURI(wfxTasksDueTodayLink));
                } },
                React__namespace.default.createElement(StyledBadge, { badgeContent: tasksAssignee.dueToday, max: 1000, variant: "standard" }, i18nHelper.translate("TASKS_ASSIGNEE.DUE_TODAY"))),
            React__namespace.default.createElement(StyledLink, { "data-qa": "ongoingTasksLink", className: "ongoing", onClick: function () {
                    var wfxTasksOngoingLink = wfxTasksAssignedRoute + "#ongoingTasks";
                    RouteIds.embedExternalPage(encodeURI(wfxTasksOngoingLink));
                } },
                React__namespace.default.createElement(StyledBadge, { badgeContent: tasksAssignee.onGoing, max: 1000, variant: "standard" }, i18nHelper.translate("TASKS_ASSIGNEE.ONGOING"))))));
};
var templateObject_1, templateObject_2;

var AssignedTasksCategory = {
    ONGOING: "ongoing",
    DUE_TODAY: "dueToday",
    OVERDUE: "overdue",
};

var TasksCardService = {
    loadAssignedTasksData: function () { return __awaiter(void 0, void 0, void 0, function () {
        var ongoingCount, dueTodayCount, overdueCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, experience.TasksService.getAssignedTasks(AssignedTasksCategory.ONGOING)];
                case 1:
                    ongoingCount = (_a.sent());
                    return [4 /*yield*/, experience.TasksService.getAssignedTasks(AssignedTasksCategory.DUE_TODAY)];
                case 2:
                    dueTodayCount = (_a.sent());
                    return [4 /*yield*/, experience.TasksService.getAssignedTasks(AssignedTasksCategory.OVERDUE)];
                case 3:
                    overdueCount = (_a.sent());
                    return [2 /*return*/, {
                            overDue: overdueCount.total,
                            dueToday: dueTodayCount.total,
                            onGoing: ongoingCount.total,
                        }];
            }
        });
    }); },
};

var TasksAssigneeCard = function () {
    var _a = React.useState(), assignedTaskCounts = _a[0], setAssignedTasksCounts = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(false), error = _c[0], setError = _c[1];
    var wfsWfxSession = RouteIds.useLocaleStorageEventListener(experience.LOCAL_STORAGE_KEYS.WFS_WFX_SESSION).currentValue;
    var getAssignedTaskCounts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, onGoing, dueToday, overDue, totalCounts;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, TasksCardService.loadAssignedTasksData()];
                case 1:
                    _a = _b.sent(), onGoing = _a.onGoing, dueToday = _a.dueToday, overDue = _a.overDue;
                    totalCounts = onGoing + dueToday + overDue;
                    return [2 /*return*/, totalCounts === 0
                            ? undefined
                            : {
                                overDue: overDue,
                                dueToday: dueToday,
                                onGoing: onGoing,
                            }];
            }
        });
    }); };
    React.useEffect(function () {
        if (RouteIds.hasValidWfxSession()) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, getAssignedTaskCounts()];
                        case 1:
                            res = _a.sent();
                            setAssignedTasksCounts(res);
                            return [3 /*break*/, 4];
                        case 2:
                            _a.sent();
                            setError(true);
                            return [3 /*break*/, 4];
                        case 3:
                            setIsLoading(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [wfsWfxSession]);
    var loader = (React__namespace.default.createElement(lighthouseComponentLibrary.CardContent, null,
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text", width: "80%" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text" }),
        React__namespace.default.createElement(Skeleton__default.default, { animation: "wave", variant: "text", width: "80%" })));
    return (React__namespace.default.createElement(lighthouseComponentLibrary.Card, { "data-qa": "tasksAssigneeCard" },
        React__namespace.default.createElement(lighthouseComponentLibrary.CardHeader, { title: i18nHelper.translate("TASKS_ASSIGNEE.CARD_TITLE"), headerIcon: "clipboarddraft" }),
        (function () {
            if (isLoading) {
                return loader;
            }
            if (error) {
                return (React__namespace.default.createElement(ErrorCard, { message: i18nHelper.translate("TASKS_ASSIGNEE.ERROR_MSG") }));
            }
            if (!assignedTaskCounts) {
                return (React__namespace.default.createElement(EmptyCard, { message: i18nHelper.translate("TASKS_ASSIGNEE.EMPTY_CARD") }));
            }
            return (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                React__namespace.default.createElement(TasksAssigneeCardContent, { tasksAssignee: assignedTaskCounts }),
                React__namespace.default.createElement(TasksAssigneeCardActions, null)));
        })()));
};

var tasksAssigneeRoutes = [
    {
        id: "tasks-assignee",
        route: "/tasksAssigneeCard",
        component: TasksAssigneeCard,
        restricted: true,
    },
];

var TasksAssigneeHubCardIds;
(function (TasksAssigneeHubCardIds) {
    TasksAssigneeHubCardIds["TasksAssigneeCard"] = "tasks/tasksAssigneeCard";
})(TasksAssigneeHubCardIds || (TasksAssigneeHubCardIds = {}));
var TasksAssigneeHubCardSpecification = {
    getId: function () { return TasksAssigneeHubCardIds.TasksAssigneeCard; },
    getName: function () { return i18nHelper.translate("TASKS_ASSIGNEE.CARD_TITLE"); },
    getConfig: function () { return ({}); },
};
/**
 * Get the hub card specifications.
 * @return HubCardSpecifications TasksAssignee object { getId: () => 'tasks/tasksAssigneeCard',
 *                                                  getName: () => 'TasksAssignee',
 *                                                  getConfig: () => ({}) }
 */
var getHubCardSpecs = function (hubCardId) {
    var _a;
    var hubCardSpecs = (_a = {},
        _a[TasksAssigneeHubCardIds.TasksAssigneeCard] = TasksAssigneeHubCardSpecification,
        _a);
    return hubCardSpecs[hubCardId];
};

/**
 * Creates and returns the hub card component for the given specification.
 * Edit mode awareness and a function to change the hub card's configuration
 * should be injected here.
 */
var create = function (cardSpecification, editMode, changeHubCardConfig) {
    if (cardSpecification.getId() === TasksAssigneeHubCardIds.TasksAssigneeCard) {
        return (React__namespace.createElement(TasksAssigneeCard, __assign({}, cardSpecification, { editMode: editMode, changeHubCardConfig: changeHubCardConfig })));
    }
    throw new Error("Unknown card id: " + cardSpecification.getId());
};
/**
 * Get the tasks assignee hub card if the current user is allowed to access.
 * @return Promise<HubCardSpecifications[]> Tasks Assignee hub card if the user is allowed to access it.
 */
var getTasksAssigneeHubCard = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hubCardSpecifications;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    shouldTasksAssigneeHubCardAppear().then(function (result) {
                        if (result) {
                            return getHubCardSpecs(TasksAssigneeHubCardIds.TasksAssigneeCard);
                        }
                        return undefined;
                    }),
                ])];
            case 1:
                hubCardSpecifications = (_a.sent()).filter(Boolean);
                return [2 /*return*/, hubCardSpecifications];
        }
    });
}); };
/**
 * Check if the Tasks Assignee hub card should appear.
 */
var shouldTasksAssigneeHubCardAppear = function () {
    var isTasksAssigneeEnabled = RouteIds.getFrameworkInstance().getNamedFeatureFlags(RouteIds.WfxFeatureFlagKey.TASKS)
        .wfx_tasks && RouteIds.hasValidWfxSession();
    return Promise.resolve(isTasksAssigneeEnabled);
};

var i18nHelper = new I18nHelper();
var tasksAssigneeHubCardFactory = {
    create: create,
    getCardSpecifications: getTasksAssigneeHubCard,
};
var TasksAssigneeModule = {
    getId: function () { return "tasks-assignee-ui"; },
    getName: function () { return "TasksAssignee"; },
    setFrameworkInstance: RouteIds.setFrameworkInstance,
    setI18nInstance: function (instance) {
        i18nHelper.setFrameworkI18n(instance);
    },
    getRouteSpecifications: function () { return tasksAssigneeRoutes; },
    getI18nResources: function () {
        return {
            "en-US": EnglishUS,
        };
    },
    getReducers: function () { return ({}); },
    getHubCardFactory: function () { return tasksAssigneeHubCardFactory; },
};

exports.BroadcastsModule = BroadcastsModule;
exports.TasksAssigneeModule = TasksAssigneeModule;
//# sourceMappingURL=index.js.map
